import { render } from "./ReagentManagement.vue?vue&type=template&id=573c71fc&scoped=true"
import script from "./ReagentManagement.vue?vue&type=script&lang=js"
export * from "./ReagentManagement.vue?vue&type=script&lang=js"

import "./ReagentManagement.vue?vue&type=style&index=0&id=573c71fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573c71fc"]])

export default __exports__